<template>
  <component :is="componentType" :items="items" :selected-item="selectedItem">
    <template>
      <slot />
    </template>
  </component>
</template>

<script>
import SlideTitleSimple from './slide-title-simple';
import SlideTitleWithMenu from './slide-title-with-menu';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  components: { SlideTitleSimple, SlideTitleWithMenu },
  computed: {
    componentType() {
      return this.type === 'with-menu' ? SlideTitleWithMenu : SlideTitleSimple;
    },
  },
};
</script>
